import Select from "react-select";
import React, {useCallback, useState} from "react";
import styled from "styled-components";
import Table from "../../components/table";
import PlatformSectionHeader from "./PlatformSectionHeader";
import PlatformTableBody from "./PlatformTableBody";
import ReportDateField from "../../components/reports/ReportDateField";
import {columnHistoryData, mediaSearchTypeByHistory, searchHistoryParams} from "./entity/common";
import {selHistoryList} from "../../services/platform/HistoryAxios";

export const dataTotalInfo = {
  totalCount:0,
  currentCount:0,
  totalPages:0,
  currentPage:1
}

function PlatformHistory() {
  const [searchHistoryParamsState, setSearchHistoryParamsState] = useState(searchHistoryParams)
  const [mediaSearchTypeByHistoryState] = useState(mediaSearchTypeByHistory)
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);
  const [open, setOpen] = useState(false);

  const handleMediaSearchTypeByHistory = (selectSearchType) => {
    setSearchHistoryParamsState({
      ...searchHistoryParamsState,
      searchKeywordType: selectSearchType,
      searchKeyword: selectSearchType.value !== null ? searchHistoryParamsState.searchKeyword: ''
    })
  }

  const handleMediaSearchValueByHistory = (event) => {
    setSearchHistoryParamsState({
      ...searchHistoryParamsState,
      searchKeyword: event.target.value
    })
  }

  const searchHistoryInfo =()=>{
    setSearchHistoryParamsState(current => ({...current}));
  }

  const resetSearchCondition = () => {
    setSearchHistoryParamsState({...searchHistoryParams});
  }

  const dataSource = useCallback(async ({skip, limit}) => {
    const params = {
      ...searchHistoryParamsState,
      currentPage: skip / limit === 0 ? 1 : skip / limit + 1,
      pageSize: limit,
    };

    const response = await selHistoryList(params);
    const content = Array.isArray(response?.content) ? response.content : [];
    if (response && typeof response === 'object') {
      const totalCount = Number(response.totalElements ?? response.totalCount ?? content.length) || 0;
      setTotalInfo({
        totalCount,
        currentCount: content.length,
        currentPage: response.currentPage ?? response.pageNumber ?? 1,
        totalPages: response.totalPages ?? 1,
      });

      return {data: content, count: totalCount};
    }
    return {data: [], count: 0};
  }, [searchHistoryParamsState]);

  return (
    <Page>
      <Card $open={open}>
        <PlatformSectionHeader title="조회 조건" description="기간과 지면 정보, 변경자를 기준으로 광고 이력을 조회합니다."
          collapsible open={open} onToggle={()=>setOpen(value=>!value)}/>
        {open&&<ConditionBody>
          <FilterGrid>
            <ReportDateField label="조회 기간"
                value={{startDate:searchHistoryParamsState.searchStartDate,endDate:searchHistoryParamsState.searchEndDate}}
                onChange={({startDate,endDate})=>setSearchHistoryParamsState(current=>({...current,searchStartDate:startDate,searchEndDate:endDate}))}/>
            <SearchField>
              <Label>이력 검색</Label>
              <SearchRow>
                <TypeSelect><Select styles={selectStyle}
                    options={mediaSearchTypeByHistoryState}
                    value={mediaSearchTypeByHistoryState.find(option => option.value === searchHistoryParamsState.searchKeywordType?.value) || mediaSearchTypeByHistoryState[0]}
                    onChange={handleMediaSearchTypeByHistory}
                    isSearchable={false}/></TypeSelect>
                <KeywordWrap><SearchIcon>⌕</SearchIcon><input type="text"
                     placeholder={searchHistoryParamsState.searchKeywordType.value != null ?'검색어를 입력해 주세요.' : '검색 항목을 선택해 주세요.'}
                     value={searchHistoryParamsState.searchKeyword || ""}
                     onChange={handleMediaSearchValueByHistory}
                     onKeyDown={e => (e.key === 'Enter') && searchHistoryInfo()}
                     disabled={!searchHistoryParamsState.searchKeywordType?.value}/></KeywordWrap>
              </SearchRow>
            </SearchField>
          </FilterGrid>
          <Footer><Guide>조회 조건을 설정한 뒤 적용 버튼을 눌러주세요.</Guide><Actions><ResetButton type="button" onClick={resetSearchCondition}>초기화</ResetButton><ApplyButton type="button" onClick={searchHistoryInfo}>적용</ApplyButton></Actions></Footer>
        </ConditionBody>}
      </Card>
      <Card>
        <PlatformSectionHeader title="광고 이력 목록" description="지면 설정의 변경 내용과 변경자를 확인합니다."
          count={totalInfo.totalCount||0} unit="건"/>
        <PlatformTableBody><Table columns={columnHistoryData}
               totalCount={[totalInfo.totalCount, '광고 이력']}
               defaultLimit={searchHistoryParamsState.pageSize}
               data={dataSource}
               idProperty={'id'}
               pagination={false}
               livePagination
               scrollThreshold={0.7}
        /></PlatformTableBody>
      </Card>
    </Page>
  )
}

export default PlatformHistory

const selectStyle={control:(base,state)=>({...base,minHeight:40,height:40,borderColor:state.isFocused?'var(--color-primary)':'var(--color-border-strong)',borderRadius:7,boxShadow:state.isFocused?'0 0 0 3px rgba(59,130,246,.1)':'none',fontSize:13,'&:hover':{borderColor:'var(--color-primary-border)'}}),valueContainer:base=>({...base,height:40,padding:'0 11px'}),indicatorsContainer:base=>({...base,height:40}),indicatorSeparator:()=>({display:'none'}),menu:base=>({...base,zIndex:40}),option:(base,state)=>({...base,backgroundColor:state.isSelected?'var(--color-primary-soft)':state.isFocused?'var(--color-surface-muted)':'var(--color-surface)',color:state.isSelected?'var(--color-primary-strong)':'var(--color-text)',fontSize:13})};
const Page=styled.div`display:flex;width:100%;flex-direction:column;gap:16px;`;
const Card=styled.section`position:relative;z-index:${({$open})=>$open?20:1};overflow:${({$open})=>$open?'visible':'hidden'};border:1px solid var(--color-border);border-radius:10px;background:var(--color-surface);box-shadow:0 5px 18px rgba(31,41,55,.045);`;
const ConditionBody=styled.div`padding:18px 20px 16px;background:var(--color-surface);`;
const FilterGrid=styled.div`display:grid;grid-template-columns:minmax(420px,1.35fr) minmax(340px,1fr);gap:16px;@media(max-width:900px){grid-template-columns:1fr;}`;
const Field=styled.div`display:flex;min-width:0;flex-direction:column;gap:7px;`;
const SearchField=styled(Field)``;
const Label=styled.div`color:var(--color-text-strong);font-size:var(--font-size-13);font-weight:700;`;
const SearchRow=styled.div`display:flex;min-width:0;`;
const TypeSelect=styled.div`width:145px;flex:0 0 145px;&>div>div{border-top-right-radius:0;border-bottom-right-radius:0;}`;
const KeywordWrap=styled.div`position:relative;min-width:0;flex:1;input{width:100%;height:40px;padding:0 12px 0 36px;border:1px solid var(--color-border-strong);border-left:0;border-radius:0 7px 7px 0;background:var(--color-surface);color:var(--color-text);font-size:var(--font-size-13);&:focus{outline:1px solid var(--color-primary);}&:disabled{background:var(--color-surface-muted);color:var(--color-text-muted);}}`;
const SearchIcon=styled.span`position:absolute;top:0;left:12px;display:flex;height:40px;align-items:center;color:var(--color-text-muted);font-size:var(--font-size-16);pointer-events:none;`;
const Footer=styled.div`display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:18px;padding-top:14px;border-top:1px solid var(--color-divider);`;
const Guide=styled.span`color:var(--color-text-muted);font-size:var(--font-size-12);`;
const Actions=styled.div`display:flex;align-items:center;gap:8px;`;
const ResetButton=styled.button`min-width:84px;height:36px;padding:0 16px;border:1px solid var(--color-border-strong);border-radius:7px;background:var(--color-surface);color:var(--color-text-muted);font-size:var(--font-size-13);font-weight:700;cursor:pointer;&:hover{border-color:var(--color-primary-border);background:var(--color-surface-muted);color:var(--color-primary-strong);}`;
const ApplyButton=styled.button`min-width:84px;height:36px;padding:0 16px;border:1px solid var(--color-primary);border-radius:7px;background:var(--color-primary);color:white;font-size:var(--font-size-13);font-weight:700;cursor:pointer;&:hover{background:var(--color-primary-dark);}`;
